import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BookmarkIcon, SearchIcon } from "../assets/svg";

export default function Nav({ onSelectCategory }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomeRoute = location.pathname === "/" && !location.search;

  const [, setIsMobile] = useState(false);

  const handleHomeClick = () => {
    if (onSelectCategory) onSelectCategory("");
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearchPageOpen = () => navigate("/search");

  return (
    <Box
      display="flex"
      justifyContent={isHomeRoute ? "flex-end" : "space-between"}
      sx={{ alignItems: { xs: "flex-start", sm: "center" } }}>
      {!isHomeRoute && (
        <Link to="/" onClick={handleHomeClick}>
          <Typography
            variant="body1"
            fontSize={20}
            lineHeight={"28px"}
            sx={{ cursor: "pointer" }}
            fontWeight={400}
            color="#000000"
            fontFamily="Avenir Book">
            Home
          </Typography>
        </Link>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
        }}>
        <Button
          onClick={() => navigate("/bookmarks")}
          variant="text"
          color="primary"
          sx={{
            borderRadius: "0px",
            padding: "10px 24px",
            display: "flex",
            alignItems: "center",
            gap: 1,
            backgroundColor: "#fff",
            boxShadow: "0px 0px 2px 0px #00000040",
            color: "#333333",
            "&:hover": {
              backgroundColor: "#fff",
              boxShadow: "0px 0px 2px 0px #00000040",
            },
          }}>
          <BookmarkIcon />
          <Typography
            variant="body1"
            fontSize={20}
            fontWeight={400}
            lineHeight={"28px"}
            textTransform={"capitalize"}
            sx={{ color: "#333333" }}
            fontFamily="Avenir Book">
            Favorites
          </Typography>
        </Button>
        <Button
          onClick={handleSearchPageOpen}
          color="primary"
          sx={{
            borderRadius: "0px",
            height: "48px",
            width: { xs: "100%", sm: "auto" },
            px: 2,
            gap: 1,
            minWidth: "48px",
            backgroundColor: "#fff",
            boxShadow: "0px 0px 2px 0px #00000040",
            color: "#333333",
            "&:hover": {
              backgroundColor: "#fff",
              boxShadow: "0px 0px 2px 0px #00000040",
            },
          }}>
          <SearchIcon />
          <Typography
            variant="body1"
            fontSize={20}
            fontWeight={400}
            lineHeight={"28px"}
            textTransform={"capitalize"}
            sx={{ color: "#333333" }}
            fontFamily="Avenir Book">
            Search
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}
